module.exports = __webpack_public_path__ + "img/slika22.a3b97cb0.jpg";